export const LOAD_LEVELS = "LOAD_LEVELS";
export const CREATE_LEVEL = "CREATE_LEVEL";
export const DELETE_LEVEL = "DELETE_LEVEL";
export const EDIT_LEVEL = "EDIT_LEVEL"